import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded font-mono font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0A0A0F] disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#00F0FF] text-black hover:bg-[#00C0CC] hover:shadow-[0_0_15px_rgba(0,240,255,0.5)] border border-transparent',
    secondary: 'bg-[#FF00AA] text-white hover:bg-[#CC0088] hover:shadow-[0_0_15px_rgba(255,0,170,0.5)] border border-transparent',
    outline: 'bg-transparent border border-[#00F0FF] text-[#00F0FF] hover:bg-[#00F0FF]/10',
    ghost: 'bg-transparent text-gray-400 hover:text-white hover:bg-white/5'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 text-sm',
    lg: 'h-12 px-6 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-158">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-159" />}
      {children}
    </button>;
}